import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { CustomerServicesInfo } from '../../../../../models/customer.model';
import { CalendarTranslateService } from '../../../../../modules/UIKit/services/calendarTranslate.service';
import { KoncentroValidators } from '../../../../../modules/UIKit/validators/koncentro-validators';
import { CustomerInfoService } from '../../../../../services/customer/customerinfo.service';
import { LoyaltyCardService } from '../../../../../services/loyalty/loyalty-card.service';
import { ServiceService } from '../../../../../services/service/service.service';

@Component({
  selector: 'app-serviceinfo-form',
  templateUrl: './serviceinfo-form.component.html',
  styleUrls: ['./serviceinfo-form.component.css']
})
export class ServiceinfoFormComponent implements OnInit {
  @Input() dialogBoxService: CustomerServicesInfo;
  @Output() serviceAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() serviceUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Output() serviceDeleted: EventEmitter<any> = new EventEmitter<any>();
  @Output() serviceAddBlacklist: EventEmitter<any> = new EventEmitter<any>();
  @Output() serviceRecovBlacklist: EventEmitter<any> = new EventEmitter<any>();
  @Output() serviceRecovery: EventEmitter<any> = new EventEmitter<any>();
  validation: any;
  addEditForm: FormGroup;
  listReasons: { value: number, label: string }[];
  serviceList: Array<{value: string, label: string}>;
  fields: any;

  show = {
    form: false
  }

  validators = {
    integerNotNegative: KoncentroValidators.integerNotNegative,
    decimalNotNegative: KoncentroValidators.decimalNotNegative,
    checkDateMajorOther_dateStart: KoncentroValidators.checkDateMajorOther('dateEnd'),
    checkDateMinorOther_dateEnd: KoncentroValidators.checkDateMinorOther('dateStart'),
  }

  public invalidSubmit: boolean;

  defaultStartDate: Date;
  defaultEndDate: Date;
  defaultBlacklistDate: Date;

  today: Date = new Date();
  oneYearFromToday: Date = new Date(this.today.setFullYear(this.today.getFullYear() + 1));

  constructor(
    private fb: FormBuilder,
    private srvService: CustomerInfoService,
    private cardService: LoyaltyCardService,
    private activatedRoute: ActivatedRoute,
    private srvServices: ServiceService,
    private calendarTranslate: CalendarTranslateService,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {

    let ValidationSS: Observable<any>;
    let translate: Observable<any>;

    this.serviceList = [];
    this.serviceList.push({label: '', value: ''});


    this.listReasons = sessionStorage.getItem('ssReasons') ? JSON.parse(sessionStorage.getItem('ssReasons')) : [{value: null, label: ''}];

    if (!sessionStorage.getItem('ssReasons')) {
      this.cardService.getReasonList({paramKey: LoyaltyCardService.SELF_SCANNING_REASON_TYPE}).subscribe(
        res => {
          for ( const reason of res.data) {
            this.listReasons.push(
              {
                label: reason.description,
                value: reason.id
              }
            );
          }
        },
        error => console.error(error),
        () => sessionStorage.setItem('ssReasons', JSON.stringify(this.listReasons))
      );
    }

    translate = this.translate.get([
      'serviceList.flg_state_dis',
      'serviceList.flg_blklst'
    ])

    // ValidationSS = this.srvService.getServicesFields();

    Observable.zip(
        this.srvService.getServicesFields(), this.srvServices.getAll(), translate
    ).subscribe(([resValidation, resServiceList, resTranslate]) => {

      this.validation = resValidation;

      this.fields = {
        flg_state_dis: resTranslate['serviceList.flg_state_dis'],
        flg_blklst: resTranslate['serviceList.flg_blklst']

      };

      this.defaultStartDate = this.dialogBoxService.dateStart ? new Date(this.dialogBoxService.dateStart) : this.today;
      this.defaultEndDate = this.dialogBoxService.dateEnd ? new Date(this.dialogBoxService.dateEnd) : this.oneYearFromToday;
      this.defaultBlacklistDate = new Date(this.dialogBoxService.dateBlklist);

      this.addEditForm = this.fb.group({
        'customerServiceId': new FormControl(this.dialogBoxService.customerServiceId) || '',
        'serviceDescription': new FormControl(this.dialogBoxService.serviceDescription) || '',
        'serviceId': new FormControl(this.dialogBoxService.serviceId) || '',
        'customerId': [(this.dialogBoxService.customerId) ? this.dialogBoxService.customerId : 0],
        'dateStart': [(this.dialogBoxService && this.dialogBoxService.dateStart) ? moment(this.dialogBoxService.dateStart).format(this.calendarTranslate.pcalendarTranslate.dateFormatFilter.toUpperCase()).toString() : ''],
        'dateEnd': [(this.dialogBoxService && this.dialogBoxService.dateEnd) ? moment(this.dialogBoxService.dateEnd).format(this.calendarTranslate.pcalendarTranslate.dateFormatFilter.toUpperCase()).toString() : ''],
        'flg_state': [(this.dialogBoxService && (this.dialogBoxService.flg_state === '0' || this.dialogBoxService.flg_state == null)) ? 0 : 1],
        'flg_blklst': [(this.dialogBoxService && (this.dialogBoxService.flg_blklst === '0' || this.dialogBoxService.flg_blklst == null)) ? 0 : 1],
        'dateBlklist': { value: this.dialogBoxService.dateBlklist ? moment(this.dialogBoxService.dateBlklist).format(this.calendarTranslate.pcalendarTranslate.dateFormatFilter.toUpperCase()) : '', disabled: false },
        'reasonId': {value: this.dialogBoxService.reasonId || '', disabled: false}
      });


      for (let service of resServiceList) {
        this.serviceList.push({ label: `${service.description}`, value: service.id.toString() });
      }

      this.show.form = true;

    });

  }

  blacklistChange() {
    if (this.addEditForm !== undefined) {
      this.addEditForm.get('dateBlklist').setValue('');
      this.addEditForm.get('reasonId').setValue(null);

    }
  }

  saveOrUpdate(): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.dialogBoxService, this.addEditForm.value);

    const param = new CustomerServicesInfo();
    param.customerServiceId = this.dialogBoxService.customerServiceId;
    param.serviceId = this.dialogBoxService.serviceId;
    param.customerId = this.dialogBoxService.customerId;
    if (this.addEditForm.get('dateStart').value != null && this.addEditForm.get('dateStart').value !== '')
      param.dateStart = moment(this.addEditForm.get('dateStart').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
    if (this.addEditForm.get('dateEnd').value != null && this.addEditForm.get('dateEnd').value !== '')
      param.dateEnd = moment(this.addEditForm.get('dateEnd').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
    param.flg_blklst = (this.addEditForm.get('flg_blklst').value) ? 1 : 0;
    param.flg_state = (this.addEditForm.get('flg_state').value) ? 1 : 0;
    if (this.addEditForm.get('dateBlklist').value != null && this.addEditForm.get('dateBlklist').value !== '')
      param.dateBlklist = moment(this.addEditForm.get('dateBlklist').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
    if (this.addEditForm.get('reasonId').value !== '')
      param.reasonId = this.addEditForm.get('reasonId').value;


    if (newData.customerServiceId === 0) {
      // insert
      this.serviceAdded.emit(param);
    } else {
      if (param.flg_blklst === 1 && this.dialogBoxService.flg_blklst === '0') {
        // caso in cui devo mettere il record in blacklist, passando data_blacklist e reason
        this.serviceAddBlacklist.emit(param);
      } else {
        if (param.flg_blklst === 0 && this.dialogBoxService.flg_blklst === '1') {
          // caso in cui devo riabilitare il record dalla blacklist
          this.serviceRecovBlacklist.emit(param);
        } else
        if (param.flg_state === 0 && this.dialogBoxService.flg_state === '1') {
          // caso in cui devo rimettere in stato valido il record
          this.serviceRecovery.emit(param);
        } else {
          if (param.flg_state === 1 && this.dialogBoxService.flg_state === '0') {
            // caso in cui devo eliminare il record
            this.serviceDeleted.emit(param);
          } else {
            // aggiorno il record solo per i campi data
            this.serviceUpdated.emit(param);
          }
        }

      }

    }


  }


}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/serviceinfo/serviceinfo-form/serviceinfo-form.component.ts